module.exports = __webpack_public_path__ + "media/images/answer-call-fe1a0bcbd84a7bcac6698fdd03bc0bbc.svg";